import script from "./HomepageInternationalamnesty.vue?vue&type=script&setup=true&lang=js"
export * from "./HomepageInternationalamnesty.vue?vue&type=script&setup=true&lang=js"

import "./HomepageInternationalamnesty.vue?vue&type=style&index=0&id=7a5582b7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a5582b7"]])

export default __exports__